<template>
  <section>
    <gs-header title="Thêm mới quận huyện"
      :breadcrumbs="[
        {title: 'Quản lý quận huyện', route: {name: 'ward'}}
      ]"
    >
    </gs-header>
    <div class="padding-all">
      <el-form :model="localWard" :rules="rules" ref="createWardForn" label-width="200px" label-position="top" @submit.prevent.native="validateBeforeSubmitCity('createWardForn')">
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Chọn tỉnh thành" prop="city_id">
              <el-select v-model="localWard.city_id" filterable placeholder="Chọn tỉnh thành" @change="getDistricts" class="width-100">
                <el-option
                  label="Chọn tỉnh thành"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="city in cities"
                  :key="city.id"
                  :label="city.name"
                  :value="city.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Chọn quận huyện" prop="district_id">
              <el-select v-model="localWard.district_id" filterable placeholder="Chọn quận huyện" class="width-100">
                <el-option
                  label="Chọn quận huyện"
                  :value="0"
                >
                </el-option>
                <el-option
                  v-for="district in districts"
                  :key="district.id"
                  :label="district.name"
                  :value="district.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localWard.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8" v-for="(carrier, index) in listCarriers" :key="index">
            <el-form-item :label="carrier.name" :key="localWard[carrier.key]">
              <el-input v-model="localWard[carrier.key]" :placeholder="carrier.name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Các loại tên" prop="map_name">
              <el-select
                v-model="mapNames"
                multiple
                filterable
                allow-create
                default-first-option
                :reserve-keyword="false"
                placeholder="Chọn các loại tên cho phường xã"
                style="width: 100%"
                no-data-text="Không có dữ liệu"
                @change="handleChange"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <button :disabled="submitting" class="ui blue basic small button" native-type="submit">Thêm mới</button>
        </el-form-item>
      </el-form>
    </div>
  </section>
</template>

<script>
import { addWard } from 'src/api/ward'
import { head, forEach } from 'lodash'
import mixins from './mixins'
export default {
  name: 'NewWard',
  mixins: [mixins],
  methods: {
    validateBeforeSubmitCity () {
      this.submitting = true
      this.toggleLoadding()
      let carriers = []
      forEach(this.dataCarriers, carrier => {
        if (carrier.id && carrier.kind_from !== 0 && carrier.kind_to !== 0) {
          carriers.push(carrier)
        }
      })
      this.localWard.carriers = carriers
      this.localWard.map_names = this.mapNames
      this.$refs.createWardForn.validate(valid => {
        if (valid) {
          this.changedData = false
          addWard(this.localWard).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Thêm quận huyện  thành công'
                })
                this.reloadGsTableAfterRedirect({name: 'ward'}, 'wards')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: 'Không tìm thấy tài nguyên',
                  type: 'warning'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('toggleLoadding', false, {root: true})
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    },
    newWard () {
      this.localWard = {
        id: 0,
        name: '',
        short_name: '',
        city_id: 0,
        district_id: 0
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewWard.vue?63b91840